module.exports = __webpack_public_path__ + "static/media/study 201115.2f2c0953.png";